import React from "react";
import { FaArrowUp } from "react-icons/fa";

import useScrollProgress from "./useScrollProgress";

const ScrollIndicator = () => {
  const { progress, visible } = useScrollProgress();

  const safeProgress = Math.min(100, Math.max(0, Number(progress || 0)));

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`
        fixed bottom-4 right-3 z-[70] max-w-[calc(100vw-1.5rem)]
        transition-all duration-300 sm:bottom-6 sm:right-6
        ${
          visible
            ? "translate-y-0 opacity-100"
            : "pointer-events-none translate-y-4 opacity-0"
        }
      `}
    >
      <div className="group relative max-w-full">
        <div
          className="max-w-full rounded-full p-[3px] shadow-xl shadow-slate-950/20"
          style={{
            background: `conic-gradient(#f97316 ${safeProgress}%, rgba(148, 163, 184, 0.35) 0)`,
          }}
        >
          <button
            type="button"
            onClick={scrollToTop}
            aria-label="Remonter en haut de page"
            title="Remonter en haut"
            className="
              flex h-11 w-11 shrink-0 items-center justify-center rounded-full
              border border-white/70 bg-white text-slate-900
              transition duration-300
              hover:-translate-y-1 hover:bg-orange-500 hover:text-white
              focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400
              dark:border-white/10 dark:bg-slate-950 dark:text-white dark:hover:bg-orange-500
              sm:h-12 sm:w-12
            "
          >
            <FaArrowUp className="h-4 w-4" />
          </button>
        </div>

        <div
          className="
            pointer-events-none absolute bottom-full right-0 mb-2 hidden
            max-w-[calc(100vw-2rem)] whitespace-nowrap rounded-2xl
            border border-slate-200 bg-white px-3 py-1.5
            text-xs font-bold text-slate-700 shadow-xl
            opacity-0 transition group-hover:opacity-100
            dark:border-white/10 dark:bg-slate-900 dark:text-white
            sm:block
          "
        >
          {Math.round(safeProgress)}%
        </div>
      </div>
    </div>
  );
};

export default ScrollIndicator;